import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiwrapperService } from 'src/app/services/apiwrapper.service';

@Injectable({
  providedIn: 'root'
})
export class TeamCodexServiceService {

  constructor(private api: ApiwrapperService) { }

  getIndicatorInterval(): Observable<any> {
    return this.api.getIndicatorInterval();
  }

  getTeamLeadershipCodexReports(teamUuid: string): Observable<any> {
    return this.api.getTeamLeadershipCodexReports(teamUuid);
  }

  getTeamLeadershipCodexQuestions(teamUuid: string, leadershipCodexUuid: string, order:string): Observable<any> {
    return this.api.getTeamLeadershipCodexQuestions(teamUuid, leadershipCodexUuid, order);
  }

  getTeamLeadershipCodexQuestionsByCategoryUuid(teamUuid: string, categoryUuid: string, order: string): Observable<any> {
    return this.api.getTeamLeadershipCodexQuestionsByCategoryUuid(teamUuid, categoryUuid, order);
  }
}
